(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discount-card-game"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('IstanovaDiscountGame');
  if (!dialog || dialog.dataset.initialized === 'true') return;
  dialog.dataset.initialized = 'true';

  const storageKey = 'istanovaSpinWheelV2';
  try {
    if (localStorage.getItem(storageKey)) return;
  } catch (e) {}

  const wheel = dialog.querySelector('[data-wheel]');
  const spin = dialog.querySelector('[data-wheel-spin]');
  const result = dialog.querySelector('[data-wheel-result]');
  const discountEl = dialog.querySelector('[data-wheel-discount]');
  const codeEl = dialog.querySelector('[data-wheel-code]');
  const claimEl = dialog.querySelector('[data-wheel-claim]');
  const closeButtons = dialog.querySelectorAll('[data-wheel-close]');

  const prizes = [10,15,20,25,30];
  const codes = {
    10:'ISTANOVASPIN10',
    15:'ISTANOVASPIN15',
    20:'ISTANOVASPIN20',
    25:'ISTANOVASPIN25',
    30:'ISTANOVASPIN30'
  };

  let spinning = false;
  let pendingDiscount = null;

  const revealResult = () => {
    if (pendingDiscount === null) return;

    const discount = pendingDiscount;
    const code = codes[discount];

    discountEl.textContent = String(discount);
    codeEl.textContent = code;
    claimEl.href = '/discount/' + encodeURIComponent(code) + '?redirect=/collections/all';
    result.hidden = false;

    try {
      localStorage.setItem(storageKey, JSON.stringify({
        played:true,
        discount,
        code
      }));
    } catch (e) {}

    pendingDiscount = null;
  };

  wheel.addEventListener('transitionend', (event) => {
    if (event.propertyName !== 'transform' || !spinning) return;
    spinning = false;
    revealResult();
  });

  spin.addEventListener('click', () => {
    if (spinning) return;

    spinning = true;
    spin.disabled = true;

    const index = Math.floor(Math.random() * prizes.length);
    pendingDiscount = prizes[index];

    const landing = (360 - index * 72) % 360;
    const rotation = 1440 + landing;

    requestAnimationFrame(() => {
      wheel.style.transform = 'rotate(' + rotation + 'deg)';
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      try {
        if (!localStorage.getItem(storageKey)) {
          localStorage.setItem(storageKey, JSON.stringify({dismissed:true}));
        }
      } catch (e) {}

      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    });
  });

  window.setTimeout(() => {
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open','');
  }, 500);
})();
  } catch(e) { console.error(e); }
})();

})();
